// Module
var code = "<p>Twenty-one days before your payment due date , we send billing statements giving you plenty of time to make your payment.</p> ";
// Exports
export default code;